<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="8">
        <b-card :header="caption">
          <b-row>
            <b-col cols="2">
              <b-form-group label="Number">
                <b-form-input type="text" class="form-control" v-model="recording.number" :readonly="true" />
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group label="Name">
                <b-form-input type="text" class="form-control" v-model="recording.name" />
              </b-form-group>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-btn size="sm" variant="primary" @click="save">Save</b-btn>
            <b-btn class="ml-1" size="sm" variant="danger" @click="del">Delete</b-btn>
          </template>
          <p><strong>Instructions:</strong> To set or update a recording, dial <strong>*98</strong> from one of the handsets and enter <strong>{{ recording.number }}</strong> when prompted for the recording number.</p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'recording',
  computed: {
    ...mapGetters({
      account: 'global/account'
    }),
  },
  data () {
    return {
      caption: 'Recording',
      recording: {
        id: null,
        number: null,
        name: null
      },
    }
  },
  methods: {
    async save () {
      const id = this.$route.params.id

      const { data } = await this.$axios.put(`/v1/recordings/${id}`, this.recording)
      Object.assign(this.recording, data)
      this.$store.dispatch('account/getRecordings')
    },
    del () {

    },
    getRecording (id) {
      this.$axios.get(`/v1/recordings/${id}`).then(({ data }) => {
        Object.assign(this.recording, data)
      })
    },
  },
  created () {
    this.getRecording(this.$route.params.id)
  },
}
</script>


